import React from "react";
import DiagnosticWizard from "./components/DiagnosticWizard/DiagnosticWizard";

const DiagnosticPage = () => {
  return (
    <DiagnosticWizard/>
  );
};

export default DiagnosticPage;